/**
 * CameraView — Renders a <video> element for camera display.
 *
 * Does NOT control camera start/stop — that's useCamera's job.
 * Applies object-fit: cover to fill the container.
 */

import type { RefObject } from 'react';

export interface CameraViewProps {
  videoRef: RefObject<HTMLVideoElement | null>;
  className?: string;
}

export function CameraView({ videoRef, className = '' }: CameraViewProps) {
  return (
    <video
      ref={videoRef}
      autoPlay
      playsInline
      muted
      className={className}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
    />
  );
}
